import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import extractText from 'flarum/common/utils/extractText';

/**
 * «Ingresar código» — un campo y Continuar.
 *
 * GO explícito de David (DELTA de PKG-FORO-LANDING-POLISH) como excepción acotada al «no UI
 * nueva» del paquete padre. El texto final de D7 pregunta «¿Recibiste una invitación o un código
 * de acceso?» y hasta aquí no había dónde escribirlo: las invitaciones sólo entraban por su
 * enlace (`/invitacion#<token>`), de modo que quien recibía el código suelto de un encuentro
 * —el caso que describe `join_2_body`— se quedaba sin puerta.
 *
 * MODAL Y NO RUTA, a diferencia de `/registro` o `/proponer-encuentro`. Aquellos son formularios
 * de cinco y catorce campos: se enlazan, se comparten y se vuelve a ellos tras un error, y por
 * eso tienen URL propia (ver `extend.php`). Esto es un campo. Una ruta nueva arrastraría un
 * `Content` class, su Blade, su entrada en `extend.php` y una pregunta de SEO sobre una pantalla
 * que no es contenido — y encima habría que desplegar el servidor para que no diera 404 en frío.
 *
 * AQUÍ NO SE VALIDA NADA DE NEGOCIO, a propósito. Lo único que se comprueba es que el campo no
 * vaya vacío; si el código existe, si caducó, si ya se usó o si es de otro grupo lo decide el
 * canje que ya vive en `InvitacionPage` + `RedeemInviteController`, que es donde están la
 * política y los mensajes de cada «no». Repetir aquí cualquier trozo de esa lógica sería una
 * segunda fuente de verdad sobre quién entra al grupo.
 */
export default class CodigoModal extends Modal<any> {
  /** Lo tecleado, sin normalizar: el trim se hace al enviar. */
  code = '';

  /** Sólo el caso vacío. Los demás los explica la pantalla de canje. */
  invalid = false;

  className() {
    return 'Modal--small CmCodigoModal';
  }

  title() {
    return this.t('title');
  }

  content() {
    return (
      <div className="Modal-body">
        <p className="CmCodigo-sub">{this.t('body')}</p>

        <input
          className="FormControl CmCodigo-input"
          name="codigo"
          data-cm-codigo="input"
          autocomplete="off"
          // `aria-invalid` y el mensaje van juntos: el borde rojo solo no llega a un lector de
          // pantalla, y el mensaje solo no marca el campo al que pertenece.
          aria-invalid={this.invalid ? 'true' : undefined}
          placeholder={extractText(this.t('placeholder'))}
          value={this.code}
          oninput={(e: any) => {
            this.code = e.target.value;
            // El error se borra al escribir, no al reenviar: dejarlo puesto mientras la persona
            // ya lo esta corrigiendo es decirle que se equivoca cuando no.
            this.invalid = false;
          }}
        />

        {this.invalid ? (
          <p className="CmCodigo-error" data-cm-codigo-error="empty">
            {this.t('error_empty')}
          </p>
        ) : null}

        {/* `type="submit"` para que Enter en el campo valga tanto como el clic: el <form> lo
            pone el propio `Modal` de Flarum alrededor de `content()`. */}
        <Button className="Button Button--primary Button--block CmCodigo-submit" type="submit">
          {this.t('submit')}
        </Button>
      </div>
    );
  }

  onsubmit(e: Event) {
    e.preventDefault();

    const code = this.code.trim();

    if (!code) {
      this.invalid = true;
      return;
    }

    // Se cierra ANTES de navegar. `m.route.set` redibuja, y un modal abierto sobre la pantalla
    // de canje taparia justo el boton «Aceptar la invitación» al que acabamos de mandar a la
    // persona.
    this.hide();

    // El fragmento no llega al servidor ni a access logs. El componente de canje lo mueve a
    // sessionStorage y limpia la barra de direcciones al montar.
    window.location.assign(app.route('umbral-comunidad.invitacion') + '#' + encodeURIComponent(code));
  }

  t(key: string) {
    return app.translator.trans('umbral-comunidad.forum.codigo.' + key);
  }
}
